import React from 'react'
import Translation from '../General/Translation'

const FilterNoMovie = ({translation}) => (
    <div className="grid-site-wrapper">
        <div className="overview-grid">
            <h3 className="no-movie title-xlarge-theatre"><Translation id="ThereCurrentlyNoFilmsTypes" trans={translation}>Zurzeit laufen keine Filme dieser Art</Translation></h3>
        </div>
    </div>
)

export default FilterNoMovie